import React from "react"
import logo1 from '../../images/logos-05.png';
import logo2 from '../../images/logos-06.png';
import logo3 from '../../images/logos-07.png';
import logo4 from '../../images/logos-19.png';
import logo5 from '../../images/logos-04.png';
import logo6 from '../../images/logos-08.png';
import logo7 from '../../images/logos-09.png';
import logo8 from '../../images/logos-10.png';
import logo9 from '../../images/logos-11.png';
import logo10 from '../../images/logos-12.png';
import logo11 from '../../images/logos-13.png';
import logo12 from '../../images/logos-14.png';

const Watch = () => (
  <section className="py-20 bg-gray-800 text-white">
    <div className="container mx-auto px-5">
      <header className="max-w-screen-md">
        <h1 className="text-3xl font-black font-heading mb-4">Watch On Demand</h1>
        <p className="mb-12 text-gray-300 text-lg">Lorem ipsum dolor sit amet consectetur adipisicing elit. Suscipit similique aliquam tempora officia eius, quae quasi eaque, repellendus nemo debitis facilis reprehenderit vitae, dolorem explicabo! Beatae nulla delectus porro magni.</p>
      </header>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
        <div className="flex flex-col">
          <div className="flex flex-col">
            <div className="p-6 sm:h-32 bg-teal-400 flex items-center justify-center">
              <img className="block" src={logo1} alt="Streaming Service" />
            </div>
            <a className="inline-block py-2 px-4 bg-teal-500 hover:bg-teal-600 duration-200 text-white font-heading text-center" href="#0">Watch Now!</a>
          </div>
        </div>
        <div className="flex flex-col">
          <div className="flex flex-col">
            <div className="p-6 sm:h-32 bg-teal-400 flex items-center justify-center">
              <img className="block" src={logo2} alt="Streaming Service" />
            </div>
            <a className="inline-block py-2 px-4 bg-teal-500 hover:bg-teal-600 duration-200 text-white font-heading text-center" href="#0">Watch Now!</a>
          </div>
        </div>
        <div className="flex flex-col">
          <div className="flex flex-col">
            <div className="p-6 sm:h-32 bg-teal-400 flex items-center justify-center">
              <img className="block" src={logo3} alt="Streaming Service" />
            </div>
            <a className="inline-block py-2 px-4 bg-teal-500 hover:bg-teal-600 duration-200 text-white font-heading text-center" href="#0">Watch Now!</a>
          </div>
        </div>
        <div className="flex flex-col">
          <div className="flex flex-col">
            <div className="p-6 sm:h-32 bg-teal-400 flex items-center justify-center">
              <img className="block" src={logo4} alt="Streaming Service" />
            </div>
            <a className="inline-block py-2 px-4 bg-teal-500 hover:bg-teal-600 duration-200 text-white font-heading text-center" href="#0">Watch Now!</a>
          </div>
        </div>
        <div className="flex flex-col">
          <div className="flex flex-col">
            <div className="p-6 sm:h-32 bg-teal-400 flex items-center justify-center">
              <img className="block" src={logo5} alt="Streaming Service" />
            </div>
            <a className="inline-block py-2 px-4 bg-teal-500 hover:bg-teal-600 duration-200 text-white font-heading text-center" href="#0">Watch Now!</a>
          </div>
        </div>
        <div className="flex flex-col">
          <div className="flex flex-col">
            <div className="p-6 sm:h-32 bg-teal-400 flex items-center justify-center">
              <img className="block" src={logo6} alt="Streaming Service" />
            </div>
            <a className="inline-block py-2 px-4 bg-teal-500 hover:bg-teal-600 duration-200 text-white font-heading text-center" href="#0">Watch Now!</a>
          </div>
        </div>
        <div className="flex flex-col">
          <div className="flex flex-col">
            <div className="p-6 sm:h-32 bg-teal-400 flex items-center justify-center">
              <img className="block" src={logo7} alt="Streaming Service" />
            </div>
            <a className="inline-block py-2 px-4 bg-teal-500 hover:bg-teal-600 duration-200 text-white font-heading text-center" href="#0">Watch Now!</a>
          </div>
        </div>
        <div className="flex flex-col">
          <div className="flex flex-col">
            <div className="p-6 sm:h-32 bg-teal-400 flex items-center justify-center">
              <img className="block" src={logo8} alt="Streaming Service" />
            </div>
            <a className="inline-block py-2 px-4 bg-teal-500 hover:bg-teal-600 duration-200 text-white font-heading text-center" href="#0">Watch Now!</a>
          </div>
        </div>
        <div className="flex flex-col">
          <div className="flex flex-col">
            <div className="p-6 sm:h-32 bg-teal-400 flex items-center justify-center">
              <img className="block" src={logo9} alt="Streaming Service" />
            </div>
            <a className="inline-block py-2 px-4 bg-teal-500 hover:bg-teal-600 duration-200 text-white font-heading text-center" href="#0">Watch Now!</a>
          </div>
        </div>
        <div className="flex flex-col">
          <div className="flex flex-col">
            <div className="p-6 sm:h-32 bg-teal-400 flex items-center justify-center">
              <img className="block" src={logo10} alt="Streaming Service" />
            </div>
            <a className="inline-block py-2 px-4 bg-teal-500 hover:bg-teal-600 duration-200 text-white font-heading text-center" href="#0">Watch Now!</a>
          </div>
        </div>
        <div className="flex flex-col">
          <div className="flex flex-col">
            <div className="p-6 sm:h-32 bg-teal-400 flex items-center justify-center">
              <img className="block" src={logo11} alt="Streaming Service" />
            </div>
            <a className="inline-block py-2 px-4 bg-teal-500 hover:bg-teal-600 duration-200 text-white font-heading text-center" href="#0">Watch Now!</a>
          </div>
        </div>
        <div className="flex flex-col">
          <div className="flex flex-col">
            <div className="p-6 sm:h-32 bg-teal-400 flex items-center justify-center">
              <img className="block" src={logo12} alt="Streaming Service" />
            </div>
            <a className="inline-block py-2 px-4 bg-teal-500 hover:bg-teal-600 duration-200 text-white font-heading text-center" href="#0">Watch Now!</a>
          </div>
        </div>
      </div>
    </div>
  </section>
)

export default Watch